export default __webpack_public_path__ + "static/media/misc-books2-768w.c0ba154a.webp";